import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from "vue";
import { projectApiStore, identifierSaveStore, appStore } from "@/hooks";
import { Modal } from "@/components/common";
import SaveProjectInputs from "./SaveProjectInputs.vue";


/**
 * A modal for creating or editing a project.
 */
const __default__ = {
  name: "SaveProjectModal",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const open = computed(() => appStore.popups.saveProject);
const isUpdate = computed(() => identifierSaveStore.isUpdate);
const modalTitle = computed(() =>
  isUpdate.value ? "Edit Project" : "Create Project"
);

/**
 * Closes the save project panel.
 */
function handleClose(): void {
  appStore.close("saveProject");
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Modal), {
    size: "md",
    loading: _unref(projectApiStore).saveProjectLoading,
    open: open.value,
    title: modalTitle.value,
    "data-cy": "modal-project-edit",
    onClose: handleClose
  }, {
    default: _withCtx(() => [
      _createVNode(SaveProjectInputs, { onSave: handleClose })
    ]),
    _: 1
  }, 8, ["loading", "open", "title"]))
}
}

})